<section class="section-container">
  <div class="section-content">
    <app-alert class="alert" customIcon="info" [dense]="true" [type]="'brand'" title="Contrato: ">
      <strong>{{contrato?.contrato || ''}}</strong>
    </app-alert>
    <div class="checkout-container">
      <div class="header">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2.5" y="4" width="2" height="16" rx="1" fill="#575757"/>
          <rect x="19.5" y="4" width="2" height="16" rx="1" fill="#575757"/>
          <rect x="7.5" y="4" width="2" height="16" rx="1" fill="#575757"/>
          <rect x="12.5" y="4" width="4" height="16" rx="2" fill="#575757"/>
        </svg>
          
        <h2> Boleto </h2>

        <strong *ngIf="(isMobileMatches | async).matches">{{planoEfetivado?.valorEntrada | currency:'BRL'}}</strong>
      </div>

      <div class="payment-container">
        <div class="payment-info-container">
          <div class="qr-code-container">
            <span class="code">{{planoEfetivado?.linhaDigitavel}}</span>
          </div>

          <button type="button" (click)="copiarCodigoBoleto()" class="copy-code-btn" mat-flat-button color="primary">
            <mat-icon>content_copy</mat-icon>
            <span>
              Copiar código
            </span>
          </button>

          <ul class="payment-instructions">
            <li class="instruction">
                Copie o código do boleto acima;
            </li>
            <li class="instruction">
                Acesse o site ou o app do seu banco para seguir com o pagamento;
            </li>
            <li class="instruction">
                Você também pode pagar em lotéricas;
            </li>
            <li class="instruction">
                Você tem até três dias úteis para pagar esse boleto.
            </li>
          </ul>
          <hr *ngIf="(isMobileMatches | async).matches"  class="payment-resume-mobile-divider" />

          <div *ngIf="hideShareActions && !(isMobileMatches | async).matches" class="autologin-only">
            <button type="button" (click)="downloadBoleto()" mat-stroked-button class="outlined" color="primary">
              <span>
                Baixar boleto
              </span>
              </button>
          </div>
        </div>

        <div class="payment-resume-info">
          <div class="resume">
            <div class="resume-item">
              <span>Parcela</span> <span class="total-installment"><strong>Entrada</strong></span>
            </div>
            <hr />
            <div class="resume-item">
              <span>Valor Atualizado</span> <strong>{{planoEfetivado?.valorEntrada | currency:'BRL'}}</strong>
            </div>
            <hr />
            <div class="resume-item">
              <span>Data de vencimento</span> <strong>{{planoEfetivado?.dataEntrada}}</strong>
            </div>
            <hr />
          </div>

          <div class="payment-instructions">
            <span class="instruction"> <strong>Fique atento:</strong> o banco tem o prazo de até três dias úteis para confirmar o pagamento do boleto. </span>
          </div>
        </div>
      </div>

      <div class="send-actions" *ngIf="hideShareActions && (isMobileMatches | async).matches">
        <button type="button" (click)="downloadBoleto()" mat-stroked-button class="outlined" color="primary">
          <span>
            Baixar boleto
          </span>
          </button>
      </div>

      <div class="send-actions" *ngIf="!hideShareActions">
        <button type="button" (click)="downloadBoleto()" mat-stroked-button class="outlined" color="primary">
          <span>
            Baixar boleto
          </span>
          </button>
        <button type="button"  (click)="sendInvoicePaymentCode('SMS')" [disabled]="disabledSms" mat-stroked-button class="outlined" color="primary">
          <span>
            Enviar por SMS
          </span>
          </button>
          <button type="button" (click)="sendInvoicePaymentCode('EMAIL')" [disabled]="disabledEmail" mat-stroked-button class="outlined" color="primary">
            <span>
              Enviar por e-mail
            </span>
          </button>
        </div>
    </div>

    <div *ngIf="(isMobileMatches | async).matches" class="installment-info">
      <div class="resume-item">
        <span>Parcela</span> <span class="total-installment"><strong>Entrada</strong></span>
      </div>
      <hr />
      <div class="resume-item">
        <span>Valor corrigido</span> <strong>{{planoEfetivado?.valorEntrada | currency:'BRL'}}</strong>
      </div>
      <hr />
      <div class="resume-item">
        <span>Data de vencimento</span> <strong>{{planoEfetivado?.dataEntrada}}</strong>
      </div>
    </div>
  </div>
</section>